import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconHandOpen = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M7.863 20.258l-4.6-5.108a1.564 1.564 0 01-.139-1.913v0a1.564 1.564 0 012.105-.473L7.7 14.247 6.4 5.163A1.585 1.585 0 017.591 3.4v0a1.585 1.585 0 011.94 1.228L10.7 10.5V3.747a1.5 1.5 0 011.5-1.5v0a1.5 1.5 0 011.5 1.5V10.5l1.181-5.911a1.545 1.545 0 011.89-1.2v0c.799.2 1.3.992 1.14 1.8L16.7 11.247l2.3-4.59a1.391 1.391 0 012.016-.536v0c.547.365.764 1.063.52 1.674l-2.259 5.648a4.493 4.493 0 00-.322 1.67v2.134a4.5 4.5 0 01-1.8 3.6v0a4.5 4.5 0 01-2.7.9h-3.247a4.5 4.5 0 01-3.345-1.49v0z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
});
IconHandOpen.displayName = "IconHandOpen";

export { IconHandOpen };
